import type {
  SupportPanelStep,
  SupportPanelViewState,
  SupportTicketView,
} from '@/viewmodel/features/support/types';
import { useState } from 'react';

export function useSupportPanelViewModel(onClose: () => void): SupportPanelViewState {
  const [step, setStep] = useState<SupportPanelStep>('menu');
  const [ticket, setTicket] = useState<SupportTicketView | null>(null);

  const close = (): void => {
    setStep('menu');
    setTicket(null);
    onClose();
  };

  const ticketCreated = (created: SupportTicketView): void => {
    setTicket(created);
    setStep('success');
  };

  return {
    step,
    ticket,
    scheduleUrl: import.meta.env.VITE_SCHEDULE_URL,
    show: setStep,
    ticketCreated,
    close,
  };
}
